export default "__VITE_ASSET__CiziyfCO__"